import { useState, useEffect } from "react"

interface GreetingResult {
  greeting: string
  emoji: string
}

const determineGreeting = (): GreetingResult => {
  const hours = new Date().getHours()
  let currentGreeting = ""
  let currentEmoji = ""

  if (hours >= 4 && hours < 12) {
    currentGreeting = "Good Morning"
    currentEmoji = "☀️"
  } else if (hours >= 12 && hours < 17) {
    currentGreeting = "Good Afternoon"
    currentEmoji = "🌞"
  } else {
    currentGreeting = "Good Evening"
    currentEmoji = "🌜"
  }

  return { greeting: currentGreeting, emoji: currentEmoji }
}

const useGreeting = (): GreetingResult => {
  const [greeting, setGreeting] = useState("")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [emoji, setEmoji] = useState("")

  useEffect(() => {
    const { greeting, emoji } = determineGreeting()
    setGreeting(greeting)
    setEmoji(emoji)
  }, [])

  return { emoji, greeting }
}

export default useGreeting
